import Vivus from "vivus";
import { set } from "../../js/lib/util";
import { createApp, defineComponent } from "vue";

export default (el: HTMLElement) => {
  const componentDefinition = defineComponent({
    name: "loading-animation",
    data() {
      return {
        isMounted: false,
      };
    },
    setup() {
      const animation = el.querySelector("#loading-animation-icon");

      if (animation) {
        new Vivus(
          animation as unknown as HTMLElement,
          {
            type: "oneByOne",
            duration: 50,
            dashGap: 20,
            start: "autostart",
            forceRender: false,
          },
          (instance: any) => {
            if (instance.getStatus() === "end") {
              set(document.body, "is-loaded");
            }
          }
        );
      } else {
        set(document.body, "is-loaded");
      }
    },
  });

  const instanceApp = createApp(componentDefinition as any);
  return instanceApp.mount(el);
};
